/* eslint-disable max-len */
import { Form, Radio, Row, Space } from 'antd';
import React, { useContext, useState } from 'react';
import { ILeiData } from 'types/leiTypes';

import ButtonComponent from 'components/atoms/ButtonComponent';
import CheckboxComponent from 'components/atoms/CheckboxComponent';
import Paragraph from 'components/atoms/Paragraph';
import SelectComponent from 'components/atoms/SelectComponent';
import Title from 'components/atoms/Title';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';
import FormWrapper from 'components/molecules/FormWrapper';

import { ETypAdresy } from 'enums/lei/typAdresy';

interface IPlatba {
    prevStep: () => void;
    isPrehled?: boolean;
    formData?: ILeiData;
    setFormData: React.Dispatch<React.SetStateAction<ILeiData | undefined>>;
}

const Platba: React.FC<IPlatba> = ({ prevStep, isPrehled, formData, setFormData }) => {
    const { lei, language } = useContext(Context);
    const [form] = Form.useForm();
    const [consentChecked, setConsentChecked] = useState<boolean>(false);
    const [, rerender] = useState<boolean>();

    const jeCZ =
        formData?.spolecnost?.adresy?.filter(e => e.typadresy === ETypAdresy.LEGALADDRESS)[0].country === 'CZ' ||
        lei?.detailData?.spolecnost?.adresy?.filter(e => e.typadresy === ETypAdresy.LEGALADDRESS)[0].country === 'CZ' ||
        lei?.data?.spolecnost?.adresy?.filter(e => e.typadresy === ETypAdresy.LEGALADDRESS)[0].country === 'CZ';

    const submitFunc = (vals: any) => {
        setFormData(
            vals
                ? {
                      ...formData,
                      ...(lei?.detailData?.platbaspe && {
                          platbaspe: lei?.detailData?.platbaspe
                      }),
                      language: language,
                      platba: {
                          ...(vals.mena &&
                              vals.typplatby === 'KARTOU' && {
                                  mena: vals.mena
                              }),
                          ...(vals.typplatby === 'KARTOU' && {
                              castka:
                                  form.getFieldValue('mena') === 'CZK'
                                      ? lei?.selectedLei?.stavlei
                                          ? jeCZ
                                              ? 1373.0
                                              : 1135.0
                                          : jeCZ
                                            ? 1875.0
                                            : 1550.0
                                      : lei?.selectedLei?.stavlei
                                        ? jeCZ
                                            ? 54.5
                                            : 45
                                        : jeCZ
                                          ? 78.5
                                          : 65
                          }),
                          typplatby: vals.typplatby
                      }
                  }
                : {
                      ...formData,
                      language: language
                  }
        );
    };

    return (
        <FormWrapper outForm={form} onFinish={vals => submitFunc(vals)}>
            <Title
                level={5}
                dividerTitle={true}
                text="LEI_PAYMENT_TITLE"
                style={{
                    marginTop: 20
                }}
            />
            <Form.Item
                style={{
                    marginBottom: 8
                }}
                name="typplatby"
                rules={[
                    {
                        required: true,
                        message: <TranslateText>NEVALIDNI_POVINNA_POLOZKA</TranslateText>
                    }
                ]}
                //  initialValue="PREVODEM"
            >
                <Radio.Group
                    style={{
                        marginBottom: 26
                    }}
                    onChange={ev => {
                        form.setFieldsValue({
                            typplatby: ev.target.value
                        });
                        rerender(pv => !pv);
                    }}
                    defaultValue={
                        lei?.detailData?.platba?.typplatby ||
                        lei?.data?.platba?.typplatby ||
                        form.getFieldValue('typplatby')
                    }
                >
                    <Space direction="vertical">
                        <Radio value={'KARTOU'}>
                            <TranslateText>LEI_PAYMENT_ONLINE</TranslateText>
                        </Radio>

                        <Radio value={'PREVODEM'}>
                            <TranslateText>LEI_PAYMENT_TRANSFER</TranslateText>
                        </Radio>
                    </Space>
                </Radio.Group>
                {form.getFieldValue('typplatby') === 'KARTOU' && (
                    <SelectComponent
                        isFormItem={true}
                        name="mena"
                        labelParagraph="MENA"
                        defaultValue={lei?.detailData?.platba?.mena}
                        onChange={rerender}
                        data={[
                            {
                                value: 'CZK',
                                labelcz: 'Česká koruna',
                                labelen: 'Czech Koruna'
                            },
                            {
                                value: 'EUR',
                                labelcz: 'Euro',
                                labelen: 'Euro'
                            }
                        ]}
                    />
                )}
                {form.getFieldValue('mena') && form.getFieldValue('typplatby') === 'KARTOU' && (
                    <div
                        style={{
                            position: 'relative',
                            top: -14
                        }}
                    >
                        <Paragraph
                            text={
                                form.getFieldValue('mena') === 'CZK'
                                    ? 'LEI_PLATOBNE_INFO_AMOUNTCR'
                                    : 'LEI_PLATOBNE_INFO_AMOUNTSK'
                            }
                            style={{
                                fontWeight: 600,
                                display: 'block'
                            }}
                        />
                        <Paragraph
                            text={
                                form.getFieldValue('mena') === 'CZK'
                                    ? lei?.selectedLei?.stavlei &&
                                      !['CANCELLED', 'PENDING_ARCHIVAL', 'PENDING_VALIDATION'].includes(
                                          lei?.selectedLei?.stavlei
                                      )
                                        ? jeCZ
                                            ? '1373,00'
                                            : '1135,00'
                                        : jeCZ
                                          ? '1875,00'
                                          : '1 550,00'
                                    : lei?.selectedLei?.stavlei &&
                                        !['CANCELLED', 'PENDING_ARCHIVAL', 'PENDING_VALIDATION'].includes(
                                            lei?.selectedLei?.stavlei
                                        )
                                      ? jeCZ
                                          ? '54,5'
                                          : '45'
                                      : jeCZ
                                        ? '78,5'
                                        : '65'
                            }
                        />
                    </div>
                )}
            </Form.Item>
            {form.getFieldValue('typplatby') && (
                <CheckboxComponent
                    name="chck3"
                    checkboxText={'LEI_SUBMIT_APPROVAL'}
                    onChange={() => setConsentChecked(pv => !pv)}
                    checked={consentChecked}
                />
            )}
            {form.getFieldValue('typplatby') === 'KARTOU' && (
                <Paragraph
                    text={'PLATEBNI_BRANA_REDIRECT'}
                    style={{
                        display: 'block',
                        marginLeft: 10,
                        marginTop: 6,
                        maxWidth: 600
                    }}
                />
            )}
            <Row
                style={{
                    marginTop: 20
                }}
            >
                <ButtonComponent buttontext="ZPET" onClick={() => prevStep()} id="OsobyZpetBtn" type="default" />
                <ButtonComponent
                    buttontext={form.getFieldValue('typplatby') === 'KARTOU' ? 'ZAPLATIT' : 'ODESLAT_ZADOST'}
                    id="OsobyPokracovatBtn"
                    style={{
                        margin: '0 8px'
                    }}
                    disabled={isPrehled || form.getFieldValue('typplatby') ? !consentChecked : false}
                    type="primary"
                    htmlType="submit"
                />
                {form.getFieldValue('typplatby') && (
                    <Paragraph
                        text="LEI_SUBMIT_INFO"
                        style={{
                            display: 'block',
                            marginTop: 16
                        }}
                    />
                )}
            </Row>
        </FormWrapper>
    );
};

export default Platba;
